import { uniqueId } from 'lodash'
import { ReactComponent as RadioCheck } from '@/assets/svgs/radio-button-check.svg'
import { ReactComponent as RadioCheckDisabled } from '@/assets/svgs/radio-button-check-disabled.svg'
import { ReactComponent as RadioUncheck } from '@/assets/svgs/radio-button-uncheck.svg'
import { ReactComponent as RadioUncheckDisabled } from '@/assets/svgs/radio-button-uncheck-disabled.svg'
import classname from 'classnames'


export const RadioButtonDesign = ({check, disabled}) => {
	if (!disabled){
		if(check){
			return <RadioCheck data-testid="radiobox-check"/>
		}

		if(!check){
			return <RadioUncheck data-testid="radiobox-uncheck" />
		}
	}

	if(disabled){
		if(check){
			return <RadioCheckDisabled data-testid="radiobox-check-disabled" />
		}

		if(!check){
			return <RadioUncheckDisabled data-testid="radiobox-uncheck-disabled" />
		}
	}

	return null;
}

const RadioButton = ({check, name, disabled, submit, ...inputRadio}) => {
	const id = uniqueId()

	const radioClass = classname(
		inputRadio.className,
		{
			'radio-button': true,
			'radio-button--disabled': disabled,
		}
	)

	const radioBtnSvg= classname(
		'radio-button__button',
		{

			'DS__icon--radio-icon': check,
			'DS__icon--radio-icon--uncheck': !check
		}
	)

	return (
		<label className={radioClass} htmlFor={id}>
			<input
				type="radio"
				className='radio-button__input'
				checked={check}
				onChange={(e)=> {
					disabled ? e.preventDefault() : submit(e)
				}}
				{...inputRadio}
				id={id}
				data-testid={`radio-button-${id}`}
			/>

			<span className={radioBtnSvg}>
				<RadioButtonDesign check={check} disabled={disabled} />
			</span>
			<span className='radio-button__text'>{name}</span>
		</label>
	)
}

export default RadioButton
